const validateForm = (inputs, rules) => {
    const errors = {};
    Object.keys(rules).forEach((key) => {
        if(Object.keys(inputs).includes(key)){
            const error = rules[key](inputs[key], inputs);
            if (error) {
                errors[key] = error;
            }
        }
    });

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
}

export default validateForm;